import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LoadScript } from '@react-google-maps/api';
import { Box, CircularProgress } from '@mui/material';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LoadScript
        googleMapsApiKey="AIzaSyCI8O91FfQgfevadyNo9pKNt52MT5RZp_4"
        libraries={['places']}
        loadingElement={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#fff'
              }}
            >
              <CircularProgress size={60} />
            </Box>
          }
    >
    
        <App />
    </LoadScript>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
